module.exports = __webpack_public_path__ + "img/symbol_13_x3.7591cdf2.png";